module.exports = __webpack_public_path__ + "img/spoken_detail_40.0dcf0198.svg";